module.exports = __webpack_public_path__ + "img/river-basin_disabled.88778469.png";